import { useCallback, useState } from "react";

import { useAxiosClient } from "@/hooks";
import { PresignedUrlRequest } from "@/types/requests";
import { PresignedUrlResponse } from "@/types/responses";

const usePresignedUrl = () => {
  const [loading, setLoading] = useState(false);

  const client = useAxiosClient("/storage");

  const getPresignedUrl = useCallback(
    async (data: PresignedUrlRequest): Promise<PresignedUrlResponse> => {
      setLoading(true);

      try {
        const response = await client.get<PresignedUrlResponse>(
          "/presigned-url",
          { params: { ...data, _t: new Date().toISOString() } }
        );
        return response.data;
      } catch (e) {
        throw e instanceof Error ? e : new Error(String(e));
      } finally {
        setLoading(false);
      }
    },
    [client]
  );

  return {
    getPresignedUrl,
    loading,
  };
};

export { usePresignedUrl };
